import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { useActiveMembership } from '@/features/session/useActiveMembership';
import { AssistantPanel } from './AssistantPanel';

const ASSISTANT_ENABLED = import.meta.env.VITE_ASSISTANT_ENABLED === 'true';

export function AssistantLauncher() {
  const { t } = useTranslation('assistant');
  const { membership } = useActiveMembership();
  const workspaceId = membership?.workspaceId ?? null;
  const [open, setOpen] = useState(false);

  // Never leak a conversation across workspaces: close the panel the instant
  // the active workspace changes (the panel below is also remounted via
  // `key={workspaceId}`, which resets its transcript).
  useEffect(() => {
    setOpen(false);
  }, [workspaceId]);

  if (!ASSISTANT_ENABLED || !workspaceId || membership?.role === 'installer') return null;

  return (
    <>
      {/* md:right-3 sits deliberately tighter to the edge than the page
          containers (px-4 / p-6), so the button reads as floating chrome
          rather than lining up with the content grid. */}
      <button
        type="button"
        data-tour="assistant-launcher"
        aria-label={t('open')}
        onClick={() => setOpen(true)}
        className="fixed right-4 z-40 bottom-[calc(4.5rem+env(safe-area-inset-bottom))] flex h-12 w-12 items-center justify-center bg-accent text-on-accent shadow-lg hover:bg-accent-hover md:bottom-6 md:right-3"
      >
        <Sparkles size={20} />
      </button>
      <AssistantPanel key={workspaceId} workspaceId={workspaceId} open={open} onOpenChange={setOpen} />
    </>
  );
}
